
import React, { useContext,useState  } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import logo from '../assets/images/logo_italianrest_transparent.png';
import { UserContext } from '../contexts/UserContext';

const Entete = () => {
    const navigate = useNavigate();
    const { user, setUser } = useContext(UserContext); // Accéder au rôle utilisateur
    const { gerant, setGerant } = useContext(UserContext);
      const [isMenuOpen, setIsMenuOpen] = useState(false);
    const handleLogout = () => {
      // Supprimer les données utilisateur du localStorage ou du contexte
      localStorage.removeItem('user');
      setUser(null);
      localStorage.removeItem('gerant');
      setGerant(null);
      navigate('/login'); // Rediriger vers la page de connexion
    };
  
    return (
        <div>
    <div className="content back-header desktop-hd">
        <div className="row">
                <div className="col-md-5 d-flex justify-content-end align-items-start padd-right" >
                     <Link className="link-menu mr-3" to="https://chezpapy-pizza-narbonne.com/">
                    <span>  Accueil</span>
                    </Link>
                    <Link className="link-menu mr-3" to="https://chezpapy-pizza-narbonne.com/notre-histoire/">
                    <span>  Notre histoire</span>
                    </Link>
                    <Link className="link-menu mr-3" to="https://chezpapy-pizza-narbonne.com/menu/">
                    <span>  Menu</span>
                    </Link>
                </div>
                <div className="col-2 card-logo ">
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="https://chezpapy-pizza-narbonne.com/">
                        <img className="logo" src={logo} alt="chez papy"/>
                    </Link>
                </div>
                <div className="col-md-5 d-flex justify-content-start align-items-start padd-left">
                    {/* <Link className="link-menu mr-3" to="https://chezpapy-pizza-narbonne.com/lequipe/">
                    <span>L’équipe</span>
                    </Link> */}
                    <Link className="link-menu mr-3 ml-3" to="https://chezpapy-pizza-narbonne.com/contact-3/">
                    <span>Contact</span>
                    </Link>
                    <Link className="btn-res mr-3" to="https://chezpapy-pizza-narbonne.com/reservation/">
                    <span> Réserver une table</span>
                    </Link>
                </div>

        </div>
    </div> 

    <div className="content mobile-hd">
      <div className="row">
        {/* Mobile Header */}
         <div className="col-3 justify-content-end align-items-start " >
            <button className="btn-menu" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            ☰
            </button>
         </div>
          <div className="col-6  justify-content-end align-items-start padd-right" >
             <Link to="/boutique">
            <img src={logo} alt="logo" className="logo-mobile" />
            </Link>
          </div>
           <div className="col-3 " >

           </div>
       
      </div>

      {/* Menu mobile */}
      {isMenuOpen && (
        <div className="mobile-menu d-md-none">
          <Link className="d-block link-mobile " to="https://chezpapy-pizza-narbonne.com/">Accueil</Link>
          <Link className="d-block link-mobile" to="https://chezpapy-pizza-narbonne.com/notre-histoire/">Notre histoire</Link>
          <Link className="d-block link-mobile" to="https://chezpapy-pizza-narbonne.com/menu/">Menu</Link>
          {/* <Link className="d-block link-mobile" to="https://chezpapy-pizza-narbonne.com/lequipe/">L’équipe</Link> */}
          <Link className="d-block link-mobile" to="https://chezpapy-pizza-narbonne.com/reservation/">Réserver une table</Link>
          <Link className="d-block link-mobile" to="/boutique">Passer une commande</Link>
          <Link className="d-block link-mobile" to="https://chezpapy-pizza-narbonne.com/contact-3/">Contact</Link>

        </div>
      )}

      
    </div>
    </div>

);
};

export default Entete;